import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to send the email
export const sendIdea = createAsyncThunk(
  'user/sendMessage',
  async ({ name, email, message }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_BASEURL}/requests/sendEmail`, {
        name,
        email,
        message,
      });

      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Redux slice
const sendSlice = createSlice({
  name: 'User Send',
  initialState: { loading: false, error: null, data: null },
  reducers: {
   
  }, // For additional synchronous reducers if needed
  extraReducers: (builder) => {
    builder
      .addCase(sendIdea.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendIdea.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Save the response data
      })
      .addCase(sendIdea.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // Save the error
      });
  },
});

// Export the reducer function
export default sendSlice.reducer;
